import { CommonModule } from '@angular/common';
import { Component, HostBinding, inject, Input } from '@angular/core';
import { Status } from '@df/core/status';
import { ActionComponentDef } from '@df/ui/api/action.component.def';
import { NotificationInitiatorService } from '../display/notification/notification-initiator.service';

@Component({
    selector: 'action, [action]',
    templateUrl: './action.component.html',
    standalone: true,
    imports: [CommonModule]
})
export class ActionComponent extends ActionComponentDef {
    @Input() set action(value: Status) {
        this.status = value;
    }

    @Input()
    icon?: string;

    @Input()
    @HostBinding('class.icon-only')
    iconOnly?: boolean;
    /**
     * If set it will trigger notification on error
     * given values is to be used as titlte
     */
    @Input()
    notification?: string;

    private notificationInitiatorService = inject(NotificationInitiatorService);

    get element() {
        return this.ngEl.nativeElement;
    }

    /**
     * Extension to support notifications
     */
    protected override onUpdate() {
        if (this.notification && this.isResultVisible && this._status?.error) {
            this.notificationInitiatorService.push({
                title: this.notification,
                message: this._status.error
            });
        }

        super.onUpdate();
    }
}
